import { useFormsContext } from '@ally/forms'
import React, { useState } from 'react'
import dayjs from 'dayjs'
import {
  Beneficiary,
  BeneficiaryClassificationCodes,
  BeneficiaryIdentifier,
} from '../../../../types'
import { BeneficiaryIdentificationField } from '../../../common/BeneficiaryIdentificationField'
import {
  CLASSIFICATION_CODES,
  IDENTIFIER_NAMES,
} from '../../../../utils/constants'

export const EditBeneIdentificationField: React.FC<{
  beneficiaryId: string
  beneficiaries: Beneficiary[] | undefined
}> = ({ beneficiaryId, beneficiaries }) => {
  const { setFieldValue, values, setFieldTouched } = useFormsContext()
  const [touchedIdentification, setTouchedIdentification] = useState('')

  // istanbul ignore next // chaining option
  const currentBeneficiary = beneficiaries?.find(
    bene => bene.beneficiaryId === beneficiaryId,
  )

  // istanbul ignore next // low value
  if (!currentBeneficiary) return <></>
  const { beneficiaryClassificationCode } = currentBeneficiary

  const changeBeneIdentificationFieldValue = (
    field: string,
    value: string | undefined,
  ): void => {
    setFieldValue(field, value)
  }

  // istanbul ignore next - low value
  const onBeneIdentificationChange = ({
    target: { value },
  }: React.BaseSyntheticEvent): void => {
    const identificationSelection = Object.keys(IDENTIFIER_NAMES).find(
      key => IDENTIFIER_NAMES[key as BeneficiaryIdentifier] === value,
    )
    setTouchedIdentification(value)

    // the api always return an array with one object for taxIdentifier
    // so we check if that object type is equal to the current selection
    // and if so, we populate the data coming from the api.

    const currentTaxIdentifier =
      currentBeneficiary &&
      currentBeneficiary.taxIdentifier &&
      identificationSelection === currentBeneficiary.taxIdentifier[0]?.type
        ? currentBeneficiary.taxIdentifier[0]
        : undefined

    if (value === 'SocialSecurityNumber') {
      setFieldValue('identificationNumber', values.maskedSsn)
    } else if (currentTaxIdentifier) {
      setFieldValue('identificationNumber', currentTaxIdentifier.typeValue)
      setFieldValue('issuer', currentTaxIdentifier.issuer)
      setFieldValue(
        'issueDate',
        dayjs(currentTaxIdentifier?.issuedDate).format('MM/DD/YYYY'),
      )
      setFieldValue(
        'expirationDate',
        dayjs(currentTaxIdentifier?.expiryDate).format('MM/DD/YYYY'),
      )
    } else if (touchedIdentification !== value) {
      setFieldTouched('identificationNumber', false)
      setFieldValue('identificationNumber', '')
      setFieldTouched('issuer', false)
      setFieldValue('issuer', '')
      setFieldTouched('issueDate', false)
      setFieldValue('issueDate', '')
      setFieldTouched('expirationDate', false)
      setFieldValue('expirationDate', '')
    } else {
      setFieldTouched('identificationNumber', true)
      setFieldValue('identificationNumber', '')
      setFieldTouched('issuer', true)
      setFieldValue('issuer', '')
      setFieldTouched('issueDate', true)
      setFieldValue('issueDate', '')
      setFieldValue('expirationDate', true)
      setFieldValue('expirationDate', '')
    }

    setFieldValue('beneIdentification', value)
  }
  return (
    <BeneficiaryIdentificationField
      beneficiaryClassification={
        CLASSIFICATION_CODES[
          beneficiaryClassificationCode as BeneficiaryClassificationCodes
        ]
      }
      changeBeneIdentificationFieldValue={changeBeneIdentificationFieldValue}
      onBeneIdentificationChange={onBeneIdentificationChange}
      ssnEditDisabled={!!values.maskedSsn && !!currentBeneficiary.taxId}
      issueDate={values.issueDate}
      expirationDate={values.expirationDate}
      maskedSsn={values.maskedSsn}
      maskedTaxId={values.maskedTaxId}
      identificationNumber={values.identificationNumber}
      beneIdentification={values.beneIdentification}
    />
  )
}
